import { render, staticRenderFns } from "./IndexMobile.vue?vue&type=template&id=d405874a&scoped=true&"
import script from "./IndexMobile.vue?vue&type=script&lang=js&"
export * from "./IndexMobile.vue?vue&type=script&lang=js&"
import style0 from "./IndexMobile.vue?vue&type=style&index=0&id=d405874a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d405874a",
  null
  
)

component.options.__file = "IndexMobile.vue"
export default component.exports